var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderProfileButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 8,
    fill: "#FFC93C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C12.2657 11 13.2917 9.97398 13.2917 8.70832C13.2917 7.44267 12.2657 6.41666 11 6.41666C9.73439 6.41666 8.70837 7.44267 8.70837 8.70832C8.70837 9.97398 9.73439 11 11 11Z",
    fill: "#180505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.1458C8.70374 12.1458 6.83374 13.6858 6.83374 15.5833C6.83374 15.7117 6.93457 15.8125 7.06291 15.8125H14.9371C15.0654 15.8125 15.1662 15.7117 15.1662 15.5833C15.1662 13.6858 13.2962 12.1458 11 12.1458Z",
    fill: "#180505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProfileButton);
export default __webpack_public_path__ + "static/media/header-profile-button.6ae3ea2d05458255d34e4d6e1b395165.svg";
export { ForwardRef as ReactComponent };